// 提款和存款類型描述的共用 mixin

import { page } from '@/api/common'

export default {
  data() {
    return {
      typeDescriptions: {} // 緩存類型描述
    }
  },

  methods: {
    /**
     * 獲取類型描述
     * @param {number} type - 類型編號 (1: bank, 2: e-wallet, 3: crypto, 4: credit)
     * @returns {Promise<string>} 描述內容
     */
    async getTypeDescription(type) {
      // 如果已經有緩存，直接返回
      if (this.typeDescriptions[type]) {
        return this.typeDescriptions[type]
      }

      const typeKeyMap = {
        1: 'bank', // 銀行卡
        2: 'e-wallet', // 電子錢包
        3: 'crypto', // 加密貨幣
        4: 'credit' // 信用卡
      }

      const key = typeKeyMap[type]
      if (!key) return ''

      try {
        const response = await page({ type: key })
        const content = response?.data?.data?.content || ''

        // 將結果存入緩存
        this.$set(this.typeDescriptions, type, content)

        return content
      } catch (error) {
        console.error('Failed to fetch type description:', error)
        return ''
      }
    },

    /**
     * 預加載類型描述
     * @param {Array<number>} types - 要預加載的類型編號陣列，預設為 [1, 2, 3, 4]
     */
    async preloadTypeDescriptions(types = [1, 2, 3, 4]) {
      const promises = types.map(type => this.getTypeDescription(type))

      try {
        await Promise.all(promises)
      } catch (error) {
        console.error('Failed to preload type descriptions:', error)
      }
    }
  }
}
